const intialState = {
    opened:[],
    signed:[]
};

export default function reducer(state=intialState, action){

    switch (action.type){
        case "GET_OPENED_ENTRETIENS_FULFILLED":{
            return {
                ...state, opened: action.payload.data.payload
            }
        }
        case "GET_ALL_ENTRETIENS_FULFILLED":{
            return {
                ...state,
                opened: action.payload.data.payload.opened,
                signed: action.payload.data.payload.signed
            }
        }
        default: {
            return state;
        }
    }
};


// WEBPACK FOOTER //
// ./src/reducers/salarie/entretiens.js